/* eslint-disable sort-keys */
export const urls: Record<
  'pt',
  Record<string, '/l/pt/pt' | `/l/pt/pt/${string}`>
> = {
  pt: {
    // Home
    '': '/l/pt/pt/home',

    // Alumni
    alumni: '/l/pt/pt/alumni',

    // B2B
    empresa: '/l/pt/pt/b2b',
    'empresa/contacto': '/l/pt/pt/b2b/apply',

    // Blog
    blog: '/l/pt/pt/blog',

    // Campus
    lisboa: '/l/pt/pt/campus/lis',
    remoto: '/l/pt/pt/campus/rmt',

    // Career
    'servicos-de-carreira': '/l/pt/pt/career',

    // Courses
    'programacao-web': '/l/pt/pt/course/wd',
    'data-analytics': '/l/pt/pt/course/da',
    'ux-ui-design': '/l/pt/pt/course/ux',
    ciberseguranca: '/l/pt/pt/course/cy',

    // FAQ
    faq: '/l/pt/pt/faq',

    // Financing Options
    financiamento: '/l/pt/pt/financing',

    // Forms
    inscrever: '/l/pt/pt/apply',
    inscrever2: '/l/pt/pt/full-apply',
    contacto: '/l/pt/pt/contact',
    'formulario-de-financiamento': '/l/pt/pt/financing-form',
    obrigado: '/l/pt/pt/thank-you',

    // Quiz
    quiz: '/l/pt/pt/quiz',
    'inteligencia-artificial/match': '/l/pt/pt/quiz-match/ai',
    'ciberseguranca/match': '/l/pt/pt/quiz-match/cy',
    'data-analytics/match': '/l/pt/pt/quiz-match/da',
    'devops-cloud-computing/match': '/l/pt/pt/quiz-match/dv',
    'marketing-digital/match': '/l/pt/pt/quiz-match/mk',
    'data-science-machine-learning/match': '/l/pt/pt/quiz-match/ml',
    'ux-ui-design/match': '/l/pt/pt/quiz-match/ux',
    'programacao-web/match': '/l/pt/pt/quiz-match/wd',

    // Syllabus Forms
    'consultoria-integracao-ia/plano-de-estudos': '/l/pt/pt/syllabus/ac',
    'inteligencia-artificial/plano-de-estudos': '/l/pt/pt/syllabus/ai',
    'engenharia-cloud/plano-de-estudos': '/l/pt/pt/syllabus/ce',
    'ciberseguranca/plano-de-estudos': '/l/pt/pt/syllabus/cy',
    'data-analytics/plano-de-estudos': '/l/pt/pt/syllabus/da',
    'engenharia-dados/plano-de-estudos': '/l/pt/pt/syllabus/de',
    'devops-cloud-computing/plano-de-estudos': '/l/pt/pt/syllabus/dv',
    'marketing-digital/plano-de-estudos': '/l/pt/pt/syllabus/mk',
    'data-science-machine-learning/plano-de-estudos': '/l/pt/pt/syllabus/ml',
    'product-manager-ia/plano-de-estudos': '/l/pt/pt/syllabus/pm',
    'ux-ui-design/plano-de-estudos': '/l/pt/pt/syllabus/ux',
    'programacao-web/plano-de-estudos': '/l/pt/pt/syllabus/wd',

    // PDP
    'consultoria-integracao-ia/remoto': '/l/pt/pt/pdp/ac/rmt',
    'inteligencia-artificial/remoto': '/l/pt/pt/pdp/ai/rmt',
    'engenharia-cloud/remoto': '/l/pt/pt/pdp/ce/rmt',
    'engenharia-dados/remoto': '/l/pt/pt/pdp/de/rmt',
    'devops-cloud-computing/remoto': '/l/pt/pt/pdp/dv/rmt',
    'marketing-digital/remoto': '/l/pt/pt/pdp/mk/rmt',
    'data-science-machine-learning/remoto': '/l/pt/pt/pdp/ml/rmt',
    'product-manager-ia/remoto': '/l/pt/pt/pdp/pm/rmt',
  },
};
/* eslint-enable sort-keys */
